export default __webpack_public_path__ + "static/media/19.04b23b8b.jpg";